<div class="c11n-banner c11n-banner--small c11n-banner--warning">
  <div class="c11n-banner__leading-icon">
    <svg class="c11n-warning-small" role="img" aria-hidden="false" focusable="true">
      <title>warning</title>
      <use xlink:href="#warning-small"></use>
    </svg>
  </div>
  <div class="c11n-banner__main">
    <div class="c11n-banner__content">
      <div class="c11n-banner__body">
        <div class="c11n-text-md--crop" role="alert">{{fd3ErrorList.zeroRecordErrorMessage}}</div>
      </div>
    </div>
  </div>
</div>
